export default window.__litium.constants;
export const ViewMode = {
    List: 'list',
    Edit: 'edit',
    Detail: 'detail',
};
export const PaginationOptions = {
    PageSize: 10, // Number of items per page
    DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
    EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};
export const ShippingIntegrationType = {
    Inline: 'Inline',
    DeliveryCheckout: 'DeliveryCheckout',
    PaymentCheckout: 'PaymentCheckout',
};
export const PaymentIntegrationType = {
    IframeCheckout: 'IframeCheckout',
    PaymentWidgets: 'PaymentWidgets',
    DirectPayment: 'DirectPayment',
};
export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_SET_PRICEREQUEST_RESPONSE = 'CART_SET_PRICEREQUEST_RESPONSE';
export const CHECKOUT_SET_PAYLOAD = 'CHECKOUT_SET_PAYLOAD';
export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_SELECTED_CONTACT = 'CHECKOUT_SET_SELECTED_CONTACT';
export const CHECKOUT_SET_GOODS_RECIPIENT = 'CHECKOUT_SET_GOODS_RECIPIENT';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE = 'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS = 'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON = 'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';
export const CHECKOUT_SET_CART_HAS_QUOTATION_PRODUCT = 'CHECKOUT_SET_CONTAINS_QUOTATION_PRODUCT';
export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';
export const FACETED_FILTER_TAB_OPEN = 'FACETED_FILTER_TAB_OPEN';
export const FACETED_CATEGORY_TAB_OPEN = 'FACETED_CATEGORY_TAB_OPEN';
export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE = 'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';
export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';
export const NAVIGATION_TOP_LEVEL_OPEN = 'NAVIGATION_TOP_LEVEL_OPEN';
export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';
export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SHOW_SEARCH_RESULT = 'QUICK_SEARCH_SHOW_SEARCH_RESULT';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';
export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';
export const ORDER_SET_LIST = 'ORDER_SET_LIST';
export const ORDER_SET_LOADING_STATUS = 'ORDER_SET_LOADING_STATUS';
export const ORDER_SET_REORDER_RESPONSE = 'ORDER_SET_REORDER_RESPONSE';
export const ORDER_APPROVER_RECEIVE = 'ORDER_APPROVER_RECEIVE';
export const ORDER_APPROVER_RECEIVE_UPDATED_ORDER = 'ORDER_APPROVER_RECEIVE_UPDATED_ORDER';
export const ORDER_APPROVER_CHANGE_MODE = 'ORDER_APPROVER_CHANGE_MODE';
export const ORDER_APPROVER_CHANGE_CURRENTPAGE = 'ORDER_APPROVER_CHANGE_CURRENTPAGE';
export const ORDER_APPROVER_SET_ORDER = 'ORDER_APPROVER_SET_ORDER';
export const ORDER_APPROVER_SET_LIST = 'ORDER_APPROVER_SET_LIST';
export const ORDER_APPROVER_SET_APPROVED_RESPONSE = 'ORDER_APPROVER_SET_APPROVED_RESPONSE';
export const ORDER_APPROVER_SET_REJECTED_RESPONSE = 'ORDER_APPROVER_SET_REJECTED_RESPONSE';
export const ORDER_APPROVER_SET_ORDER_ACTION = 'ORDER_APPROVER_SET_ORDER_ACTION';
// Variant table
export const VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN = 'VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN';
export const VARIANT_TABLE_SET_QUERY_PARAMS = 'VARIANT_TABLE_SET_QUERY_PARAMS';
export const VARIANT_TABLE_SET_STATE = 'VARIANT_TABLE_SET_STATE';
export const VARIANT_TABLE_MOBILE_BREAKPOINT = 1240;
//Organization selector search
export const ORGANIZATION_SEARCH_QUERY = 'ORGANIZATION_SEARCH_QUERY';
export const ORGANIZATION_SEARCH_RECEIVE = 'ORGANIZATION_SEARCH_RECEIVE';
export const ORGANIZATION_SEARCH_ERROR = 'ORGANIZATION_SEARCH_ERROR';
export const ORGANIZATION_SEARCH_SHOW_FULL_FORM = 'ORGANIZATION_SEARCH_SHOW_FULL_FORM';
export const ORGANIZATION_SEARCH_SELECT_ITEM = 'ORGANIZATION_SEARCH_SELECT_ITEM';
export const ORGANIZATION_TOGGLE_RESULT = 'ORGANIZATION_TOGGLE_RESULT';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';
// Bulk add to cart
export const BULK_ADD_TO_CART_SET_STATE = 'BULK_ADD_TO_CART_SET_STATE';
export const BULK_ADD_TO_CART_VISIBILITY = 'BULK_ADD_TO_CART_VISIBILITY';
export const BULK_ADD_TO_CART_SET_RESULT = 'BULK_ADD_TO_CART_SET_RESULT';
export const BULK_ADD_TO_CART_SET_STEP = 'BULK_ADD_TO_CART_SET_STEP';
export const BULK_ADD_TO_CART_SET_LOADING_STATE = 'BULK_ADD_TO_CART_SET_LOADING_sTATE';
export const BULK_ADD_TO_CART_SET_INPUT_VALUE = 'BULK_ADD_TO_CART_SET_INPUT_VALUE';
export const BULK_ADD_TO_CART_STEPS = {
    FORM: 1,
    SUMMARY: 2
};
// Favorites
export const FAVORITES_RECEIVE = 'FAVORITES_RECEIVE';
